<script lang="ts">
  import { memberProfilePanel } from "$stores/memberPanel";
  import ToolTip from "$components/+blocks/Tooltip/Tooltip.svelte";
  import { communitySlug, primaryColor } from "$stores/community";
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import { processRoleLabel } from "$utils/strings.js";
  import { logoImage } from "$stores/community";
  import type { Author } from "models/forums";
  import type { Card } from "../ForumCard.svelte";
  import Badge from "$components/+blocks/Badge/Badge.svelte";

  export let author: Author;
  export let type: Card;
  export let showAuthorBadge: boolean = false;

  const ROLES_PREVIEW_COUNT = 4;

  $: namedRoles = author.roles?.filter((role) => !role.isMembers && !role.isTeam && !role.isAdmins);
  $: isTeam = author?.roles?.find((role) => role.isTeam);
</script>

<div class="inline-flex flex-wrap items-center gap-2">
  <button
    class="not-prose group inline-flex items-center gap-2 hover:cursor-pointer"
    on:click|stopPropagation|preventDefault={() =>
      author && memberProfilePanel.clearAndShow(author.uuid, $communitySlug)}
    on:keydown={(event) =>
      event.key === "Enter" &&
      author &&
      memberProfilePanel.clearAndShow(author.uuid, $communitySlug)}
    aria-label="open profile for {author.handle}"
  >
    <span
      class="text-sm font-medium text-neutral-500 transition-colors group-hover:text-neutral-800 md:text-[13px] dark:text-neutral-400 dark:group-hover:text-neutral-300"
    >
      {author.handle}
    </span>
    {#if isTeam}
      <ToolTip>
        <span slot="tip">Team member</span>
        <Avatar
          mainImage={$logoImage}
          backgroundColor={$primaryColor}
          label={author.handle && author.handle[0]}
          radius="rounded-[3px]"
        />
      </ToolTip>
    {/if}
  </button>

  <!-- ROLE BADGES -->
  <!-- only render if content to show - to prevent margin -->
  {#if (type === "reply" && showAuthorBadge) || (namedRoles && namedRoles.length)}
    <div class="hidden flex-wrap gap-2 @xl/main-panel-container:inline-flex">
      {#if type === "reply" && showAuthorBadge}
        <Badge
          fontSize="text-xxs"
          fontWeight="font-semibold"
          textColor="text-neutral-500 dark:text-neutral-400"
          backgroundColor="bg-transparent"
          radius="rounded-none"
          verticalPadding="py-1"
          horizontalPadding="px-0"
          lineHeight={"leading-none"}
        >
          Author
        </Badge>
      {/if}

      {#if namedRoles && namedRoles.length}
        {#each namedRoles.slice(0, ROLES_PREVIEW_COUNT) as role, i (i)}
          <Badge
            fontSize="text-xxs"
            verticalPadding="py-0.5"
            horizontalPadding="px-1.5"
            lineHeight="leading-none"
            radius="rounded"
            customColor={role.color || undefined}
          >
            {processRoleLabel(role?.name || "")}
          </Badge>
        {/each}
      {/if}

      {#if namedRoles && namedRoles.length > ROLES_PREVIEW_COUNT}
        <ToolTip>
          <span slot="tip"
            >{namedRoles
              .slice(ROLES_PREVIEW_COUNT)
              .map((role) => role.name)
              .join(", ")}</span
          >
          <Avatar
            wrapperClasses="bg-neutral-200 dark:bg-white/30 text-xxs"
            size="size-5"
            label={`+${Math.abs(namedRoles.length - ROLES_PREVIEW_COUNT)}`}
          />
        </ToolTip>
      {/if}
    </div>
  {/if}
</div>
